import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type EmptyCasesMessageProps = {
  text: string;
};

export const EmptyCasesMessage: FC<EmptyCasesMessageProps> = ({ text }) => {
  return (
    <EmptyContainer>
      <Icon style={{ color: COLORS.systemDark100 }} name="folders" size="s44" />
      <span>{text}</span>
    </EmptyContainer>
  );
};

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  color: ${COLORS.systemDark200};
`;
